import { DropdownBaseDataControl } from './DropdownBaseDataControl';

export class DropdownDataSourceDataControl extends DropdownBaseDataControl {

    // get list of choices from the specified datasource
    init(metaData) {
        var self = this;
        this.metaData = metaData;

        return new Promise(function (resolve, reject) {

            var dataSourceData = metaData.dataSourceData;
            if (!dataSourceData) {
                throw new Error(" DropdownDataSourceDataControl requires Data Source Data");
            }

            self.dataManager.getDataSourceItems(dataSourceData.name)
                .then(items => {

                    self.dataSourceItems = items;
                    var value = (items && items.length === 1) ? items[0][dataSourceData.valueMemberName] :
                        dataSourceData.defaultSelectedId ? dataSourceData.defaultSelectedId : -1;

                    self.setState({
                        items: items,
                        defaultSelectedId: dataSourceData.defaultSelectedId,
                        value: value
                    });

                    if (value !== -1)
                        self.setValue(value);

                    resolve(self);
                })
                .catch(error => {
                    reject(error)
                });
        });
    }
}